import { formatTitle } from "@itandi/tools/vanilla";
import Head from "next/head";
import type React from "react";

type Props = {
	title: string;
};

export const NskHead: React.FC<Props> = ({ title }: Props) => (
	<Head>
		<title>{formatTitle(title, "nsk")}</title>
	</Head>
);
